import { useCallback, useRef, useState } from "react";
import TagManager from "react-gtm-module";

import { checkoutRequest, secureCheckoutUrl } from "../api/checkout";
import { useCartIdContext } from "../providers";

export function useCheckout() {
  const cartId = useCartIdContext();
  const inProgress = useRef(false);
  const [isCheckingOut, setCheckingOut] = useState(false);
  const [checkoutError, setCheckoutError] = useState("");
  const checkout = useCallback(async () => {
    if (inProgress.current) return;
    inProgress.current = true;
    setCheckingOut(true);
    setCheckoutError("");
    try {
      const result = await checkoutRequest<{ url: string; sessionId?: string }>("session", {
        cartId,
      });
      const url = secureCheckoutUrl(result.url);
      try { if (result.sessionId) sessionStorage.setItem(`stripeCart:${result.sessionId}`, cartId); } catch { /* Storage may be disabled. */ }
      // Analytics must never prevent payment navigation, including when browser-blocked.
      if (process.env.REACT_APP_CHECKOUT_PREVIEW !== "true") {
        try {
          TagManager.dataLayer({ dataLayer: { event: "InitiateCheckout" } });
        } catch {
          /* optional analytics */
        }
        try {
          if (typeof fbq === "function") fbq("track", "InitiateCheckout");
        } catch {
          /* optional analytics */
        }
      }
      window.location.assign(url);
    } catch (error) {
      setCheckoutError(
        error instanceof Error && error.name !== "AbortError"
          ? error.message
          : "Checkout took too long to respond. Your basket has been kept. Please try again."
      );
      inProgress.current = false;
      setCheckingOut(false);
    }
  }, [cartId]);
  return { checkout, isCheckingOut, checkoutError };
}
